var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTheft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1141_3373",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    fill: "#D9D9D9",
    stroke: "#005FC8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1141_3373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.9608 22.8831L58.9003 31.929H45.0546L47.8759 22.8831H55.9608Z",
    stroke: "#005FC8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.239 14.7593C17.535 14.7295 17.7861 14.7498 17.9587 14.7769C18.0445 14.7903 18.1093 14.8057 18.1492 14.8159C18.169 14.821 18.1828 14.8247 18.1892 14.8267L18.1912 14.8276H18.1921L18.2292 14.8403L18.2742 14.8491L28.5066 16.9995C29.3087 17.2879 29.8012 17.6872 30.1101 18.0972C30.4274 18.5184 30.5838 18.9925 30.6453 19.4575C30.7071 19.9257 30.6709 20.3692 30.616 20.7007C30.5889 20.8644 30.5581 20.9963 30.5349 21.0845C30.5234 21.1283 30.5136 21.1611 30.5076 21.1812C30.5046 21.1911 30.5028 21.1983 30.5017 21.2017H30.5007V21.2036L30.4832 21.2554L30.4724 21.312L26.8464 41.8345L8.53882 37.4663L12.0017 25.77L12.5896 23.7856L10.8669 24.9331L7.39038 27.2485L4.76636 23.1577L14.9988 16.0396L15.073 15.9868L15.1335 15.9185C15.8805 15.0687 16.6621 14.8175 17.239 14.7593Z",
    stroke: "#005FC8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8031 3.3999C27.8031 3.3999 28.9817 8.48378 29.1872 9.22199C29.3928 9.96019 29.2544 11.3229 28.095 12.231C26.9356 13.139 26.4655 12.9144 26.4655 12.9144L26.2202 15.7576L21.595 14.7811C21.595 14.7811 22.0925 13.1719 22.2734 12.5569C22.4557 11.942 22.2378 11.4434 21.9431 10.8627C21.6485 10.282 20.4727 7.91815 20.4727 7.91815",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.5214 87.9155C-15.5214 87.9155 -2.87777 95.2729 0.39208 97.1766C3.66193 99.0803 7.05375 96.726 7.60055 93.9197C8.10487 91.3285 15.5025 53.5774 16.6289 47.8279L18.3694 48.1401L42.6781 121.109",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9382 72.6528L27.2853 44.3298L27.4471 42.7493L7.59636 38.012L7.24553 39.5514L6.56032 44.4545L6.55758 44.4531L0.475607 88.0167L-12.2817 80.8743",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6262 31.9488C20.2767 31.5173 19.6422 31.453 19.2133 31.8063L16.1805 34.3099L3.21621 30.9558L7.14798 28.2947L3.70956 22.9041L-6.17124 29.6862C-6.35762 29.793 -6.53577 29.9149 -6.70297 30.0519L-6.71119 30.0574C-7.12369 30.397 -7.47452 30.8216 -7.72805 31.3229C-9.0327 33.9018 -7.20181 36.9587 -4.31157 37.0272L16.2997 37.5216C16.9 37.5366 17.4714 37.2641 17.8401 36.7902L20.6385 33.1882C20.9236 32.8226 20.9181 32.3076 20.6262 31.9474V31.9488Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3455 11.2449C24.0732 12.6542 25.7438 13.2938 27.2279 12.7309C28.697 12.1735 29.5234 10.6135 29.1575 9.08645L27.7843 3.35065C27.1717 0.790906 24.4487 -0.647153 21.9874 0.285532C19.559 1.20589 18.4668 4.0286 19.6426 6.34319L21.8668 10.6875C21.9682 10.8861 22.0628 11.0874 22.1505 11.2928C22.3465 11.7462 22.3711 12.2557 22.23 12.7282L21.6174 14.7825",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4716 12.9143L26.218 15.6644",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4032 90.5463L49.7793 117.969C50.2301 119.486 51.7787 120.394 53.3232 120.046L55.3789 119.583L56.1696 120.91C56.3423 121.185 56.2696 121.548 56.001 121.734L45.7817 127.859C45.4473 128.092 44.9828 127.937 44.8553 127.551L18.3827 48.1386L16.6875 47.7825L7.59877 93.9196C6.95467 97.1915 3.27506 98.8542 0.391677 97.1765L-15.5218 87.9167C-16.751 87.2018 -18.3147 87.4593 -19.2493 88.5317L-20.9884 90.5271L-22.5 89.7068L-17.4349 77.99L0.475275 88.0181L7.24383 39.5527L7.59466 38.0133L7.81393 37.3203",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32483 32.5378L14.4146 16.4165C14.9737 14.7415 16.7005 13.7499 18.43 14.1142L28.7192 16.2754C30.4706 16.6438 31.656 18.2818 31.4573 20.0595L27.4474 42.748L27.2624 44.2518L35.9372 72.6514",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 14.6045L-6.22266 29.7151",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1805 34.3114L-3.2303 29.2905C-5.02145 28.8276 -6.89346 29.674 -7.72805 31.323C-9.0327 33.9019 -7.20181 36.9588 -4.31157 37.0273L16.2997 37.5217C16.9 37.5367 17.4714 37.2642 17.8401 36.7903L20.6385 33.1883C20.9236 32.8226 20.9181 32.3077 20.6262 31.9475C20.2767 31.5161 19.6422 31.4517 19.2133 31.805L16.1805 34.3086V34.3114Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.21521 30.9574L11.6187 25.2695",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.70874 22.9041L7.14852 28.2961",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.285 44.33L7.24524 39.5515",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9223 32.6459H44.0253L47.3705 22.1001H56.5771L59.9223 32.6459Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3034 19.7363V22.1002H49.3699V19.7363C49.3699 19.2378 49.6741 18.8105 50.1085 18.6311C50.2497 18.5722 50.4045 18.5393 50.5676 18.5393H53.1057C53.7676 18.5393 54.3034 19.0748 54.3034 19.7363Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5102 35.7454L30.1833 26.8938",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5838 28.5371L31.2126 18.2598",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1086 18.6312C49.6741 18.8106 49.3699 19.2379 49.3699 19.7364V20.8636L46.8072 20.828L40.5896 35.2894C40.1099 36.4015 39.0314 37.052 37.909 37.052C37.4293 37.052 36.9415 36.9342 36.4892 36.6809C35.0763 35.8892 34.5802 34.0992 35.3847 32.694L43.425 18.6627C43.917 17.8053 44.9174 17.3753 45.8794 17.6081L50.1086 18.6312Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheft);
export default __webpack_public_path__ + "static/media/theft.be6de02c.svg";
export { ForwardRef as ReactComponent };